(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/focus-trap/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/lb-utils/focus-trap/assets/javascripts/constants.js');

'use strict';

const defaultSelectors = ['a[href]:not([disabled])', 'button:not([disabled])', 'textarea:not([disabled])', 'input:not([disabled])', 'select:not([disabled])', '[tabindex]:not([disabled])'];
const state = {
  target: null,
  focusableElements: [],
  first: null,
  last: null,
  initiator: null
};
const toExport = {
  defaultSelectors,
  state
};
setGlobal('svs.components.lbUtils.focusTrap.constants', toExport);

 })(window);